export default "__VITE_ASSET__941b9bbf__"